import React from 'react';
import { Box, Card, CardContent, SvgIconProps, Typography } from '@mui/material';
import { SvgIcon } from '@mui/material';

interface CVCardProps {
    icon: React.ComponentType<SvgIconProps>;
    title: string;
    subtitle?: string;
    period: string;
    location?: string;
    points?: string[];
}

export const CVCard: React.FC<CVCardProps> = ({
    icon: Icon,
    title,
    subtitle,
    period,
    location,
    points
}) => (
    <Card>
        <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                <Icon sx={{ mr: 2, mt: 0.5 }} />
                <Box>
                    <Typography variant="h6">{title}</Typography>
                    {subtitle && (
                        <Typography color="text.secondary">{subtitle}</Typography>
                    )}
                    <Typography variant="body2">
                        {period} {location && `| ${location}`}
                    </Typography>
                    {points && (
                        <Box component="ul" sx={{ mt: 1, pl: 2 }}>
                            {points.map((point, idx) => (
                                <li key={idx}>
                                    <Typography variant="body2">{point}</Typography>
                                </li>
                            ))}
                        </Box>
                    )}
                </Box>
            </Box>
        </CardContent>
    </Card>
); 